// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"Q71H1","rc-tabs-tab-active":"pR8V1","input-suffix":"W4WIT","nav-item":"i7zVf","banner-info":"l1NCU","banner-info-logo":"bNEs0","banner-info-content":"_1TLYZ"};